import { AddSquareSmallIcon } from "assets/icons";
import { ExpertiseSectionProps } from "interfaces/ExternalPage/SpeakerLandingPage.interface";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ChevronUp from "assets/icons/ChevronUp";
import ChevronDown from "assets/icons/ChevronDown";
import { Tooltip } from "antd";

export default function ExpertiseSection({ expertise }: ExpertiseSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  function handleSeeAllExpertise() {
    setIsExpanded(!isExpanded);
  }

  const displayedExpertise = isExpanded ? expertise : expertise.slice(0, 5);

  return (
    <section className="mx-auto">
      <motion.h2 className="text-lg sm:text-xl font-monaMedium text-[#333333] mb-2">
        Expertise
      </motion.h2>
      <div className="flex flex-wrap gap-2 sm:gap-[15px]">
        <AnimatePresence mode="popLayout">
          {displayedExpertise.map((item, index) => (
            <Tooltip
              key={item}
              title={item.length > 30 ? item : ""}
              color="#ffffff"
              styles={{ body: { color: "#000000" } }}
              mouseEnterDelay={0.6}
            >
              <motion.span
                initial={{ opacity: 0, scale: 0.8, y: -10 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.8, y: -10 }}
                transition={{
                  duration: 0.4,
                  delay: index * 0.05,
                  ease: [0.4, 0.0, 0.2, 1],
                }}
                layout
                className="px-[6px] h-[32px] flex items-center bg-[#FCEDDE] text-[#B93815] rounded-[50px] font-monaMedium border border-[#F9DBAF] active:scale-95 cursor-pointer text-sm sm:text-base max-w-full overflow-hidden"
              >
                <span className="truncate">{item}</span>
              </motion.span>
            </Tooltip>
          ))}
        </AnimatePresence>
      </div>

      {expertise.length > 5 && (
        <motion.button
          layout
          transition={{ duration: 0.4, ease: [0.4, 0.0, 0.2, 1] }}
          whileTap={{ scale: 0.98 }}
          className="flex h-[44px] items-center gap-2 rounded-lg bg-[#F2ECE2] px-3 text-sm sm:text-base font-monaMedium text-[#20242A] transition-colors duration-200 hover:bg-primary hover:text-[#F6F3EF] mt-2"
          onClick={handleSeeAllExpertise}
        >
          {isExpanded ? "See less" : `See all ${expertise.length} expertise`}
          <AnimatePresence mode="wait">
            {isExpanded ? (
              <motion.span
                key="icon"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                transition={{ duration: 0.2 }}
                className="flex items-center"
              >
                <ChevronUp stroke="currentColor" />
              </motion.span>
            ) : (
              <motion.span
                key="icon"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                transition={{ duration: 0.2 }}
                className="flex items-center"
              >
                <ChevronDown stroke="currentColor" />
              </motion.span>
            )}
          </AnimatePresence>
        </motion.button>
      )}
    </section>
  );
}
